import React from 'react';
import DatePicker from "react-datepicker";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

import {
  addPlant,
  toggleModal,
} from './actions';

import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

export const ModalForm = ({
  addPlant,
  modal,
  toggleModal
}) => {
  const { user } = useAuth0();
  const feildNames = ['plantName', 'waterStartTime', 'wateringCycle'];
  const onSubmitForm = async (e) => {
    e.preventDefault();
    const reqObj = {};
    const userId = user.sub.split('|')[1];

    feildNames.forEach((name) => {
      if (_.get(e, `currentTarget[${name}].value`, false)) {
        reqObj[name] = e.currentTarget[name].value;
      }
    });

    if (!Object.keys(reqObj).length) {
      toggleModal();
      return;
    }

    addPlant(userId, reqObj);
    toggleModal();
  };

  return (
    <Form
      id="add-plant-form"
      className="Add-plant-form"
      onSubmit={onSubmitForm.bind(this)}
    >
      <FormGroup row={true} >
        <Col>
          <Label for="plantName">Name</Label>
          <Input
            id="plantName"
            name="plantName"
            placeholder={'Name'}
            type="plantName"
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col className="edit-plant-form_input water-start-time">
          <Label for="waterStartTime">
            Watering Start Time
          </Label>
          <DatePicker
            className="water-start-time-input form-control"
            id="waterStartTime"
            name="waterStartTime"
            selected={new Date()}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Col className="edit-plant-form_input">
          <Label for="wateringCycle">Watering Cycle</Label>
          <Input
            id="wateringCycle"
            name="wateringCycle"
            type="select"
          >
            <option>
              Select Water Cycle
            </option>
            <option>
              daily
            </option>
            <option>
              weekly
            </option>
            <option>
              bi-weekly
            </option>
          </Input>
        </Col>
      </FormGroup>
      <div className="btn-container">
        <Button
          className="btn-close"
          color="secondary"
          onClick={toggleModal.bind(this, !modal)}
        >
          close
        </Button>
        <Button
          className="btn-submit"
          color="success"
        >
          Add
        </Button>
      </div>
    </Form>
  );
};

const mapStateToProps = state => ({
  modal: state.addPlant.modal
});

const mapDispatchToProps = dispatch => bindActionCreators({
  addPlant,
  toggleModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ModalForm);
